import CloseIcon from '@mui/icons-material/Close';

import { StyledDialog } from './styled'
import { isValidVideoPath } from '@utils/image';

export interface SimpleDialogProps {
  url: string;
  isOpen: boolean;
  onClose: () => void;
}

const ImageDialog = (props: SimpleDialogProps) => {
  const { onClose, isOpen, url } = props;

  if (url.includes('data:video') || isValidVideoPath(url)) {
    return (
      <StyledDialog onClose={onClose} open={isOpen}>
        <CloseIcon onClick={onClose} />
        {url ? (
        // eslint-disable-next-line jsx-a11y/media-has-caption
          <video width="400" height="400" controls>
            <source src={url} type="video/mp4" />
          </video>
        ) : <div>Loading...</div>}
      </StyledDialog>
    );
  }

  return (
    <StyledDialog onClose={onClose} open={isOpen}>
      <CloseIcon onClick={onClose} />
      {url ? <img src={url} alt="products" /> : <div>Loading...</div>}
    </StyledDialog>
  );
}

export default ImageDialog
